/**
 * Connect 页 data —— 占位
 * noindex：领导决定只让 Google 收录 Home + Pro
 */
import type { PageData } from '@/content/types';

export const data: PageData = {
  seo: {
    title: 'LoEvent Connect',
    description: 'Your intelligent event companion for filtering sessions and matchmaking.',
    ogImage: '/images/ogimage.jpg',
    index: false,
  },
  sections: [
    {
      type: 'hero',
      data: {
        headline: 'LoEvent Connect',
        subheadline: 'Turn attendance into convertible opportunities.',
        cta: { label: 'Get Started', href: 'https://app.loevent.com/connect' },
      },
    },
    {
      type: 'cta-band',
      data: {
        title: 'Stop missing critical sessions.',
        cta: { label: 'Try Connect', href: 'https://app.loevent.com/connect' },
      },
    },
  ],
};
